import { Configuration } from "Models/configuration";

export const getConfig = (state: any): Configuration | undefined =>
    state.configuration;
